export default "<p>food-results works!</p>\n";